import React, { useContext } from "react";
import ReactDOM from "react-dom";
import { QueueContext } from "../../context/QueueProvider";
import { ToastContainer } from "./styles";
const Toast = props => {
  const queue = useContext(QueueContext);

  if (!queue.addToQueueMessage) return null;

  return ReactDOM.createPortal(
    <ToastContainer>
      <div onClick={props.openQueue} className="toast">
        <p> Track Added To Queue</p>
      </div>
    </ToastContainer>,
    document.body
  );
};

export default Toast;
